export default __webpack_public_path__ + "static/media/laptop-image.e51b25ea.svg";